import { render, staticRenderFns } from "./BrandExplorer.vue?vue&type=template&id=13f55c14&scoped=true&"
import script from "./BrandExplorer.vue?vue&type=script&lang=js&"
export * from "./BrandExplorer.vue?vue&type=script&lang=js&"
import style0 from "./BrandExplorer.vue?vue&type=style&index=0&id=13f55c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f55c14",
  null
  
)

export default component.exports